import React, { useState, useEffect, useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import Fade from 'embla-carousel-fade';
import './SimpleSlider.css';

// Εικονίδια για τα βελάκια (μπορείς να βάλεις δικά σου SVG)
const PrevIcon = () => <span>&#10094;</span>;
const NextIcon = () => <span>&#10095;</span>;

export default function EmblaSlider() {
  // 1. Ρύθμιση του Hook και των Plugins
  const isTouchDevice = () => {
    if (typeof window === 'undefined') return false;
    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  };

  // --- ΒΗΜΑ 2: Πέρναμε τη συνάρτηση στο watchDrag ---
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { 
      loop: true, 
      duration: 20, 
      // Αν είναι συσκευή αφής -> TRUE (επιτρέπεται το swipe)
      // Αν είναι Desktop -> FALSE (απαγορεύεται το swipe)
      watchDrag: isTouchDevice() 
    }, 
    [
      Autoplay({ delay: 3000, stopOnInteraction: false }), 
      Fade(), 
    ]
  );

  // 2. State για τις τελείες (Pagination)
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);

  // 3. Λειτουργίες Navigation (Previous/Next)
  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi]);
  const scrollTo = useCallback((index) => emblaApi && emblaApi.scrollTo(index), [emblaApi]);

  // 4. Συγχρονισμός Dots με το Slide που παίζει
  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    setScrollSnaps(emblaApi.scrollSnapList());
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', onSelect);
  }, [emblaApi, onSelect]);

  const imageUrls = [
      "./img/slider/SLIDER 1.jpg",
      "./img/slider/SLIDER 2.jpg",
      "./img/slider/SLIDER 3.jpg",
      "./img/slider/SLIDER 4.jpg",
      "./img/slider/28β. Blurred.png",
    ];


  return (
    <div className="embla">
      {/* Viewport & Container */}
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {imageUrls.map((imageUrl, index) => (
            <div className="embla__slide" key={index}>
              <img
                src={imageUrl}
                alt={`Slide ${index}`}
                className="embla__slide__img"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Arrows */}
      <button className="embla__prev" onClick={scrollPrev} aria-label="Previous">
        <PrevIcon />
      </button>
      <button className="embla__next" onClick={scrollNext} aria-label="Next">
        <NextIcon />
      </button>

      {/* Pagination Dots */}
      <div className="embla__dots">
        {scrollSnaps.map((_, index) => (
          <button
            key={index}
            onClick={() => scrollTo(index)}
            className={`embla__dot ${index === selectedIndex ? 'embla__dot--selected' : ''}`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
